import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	daysLeft: {
		id: 'jsm-grace-period-banner.gp-awareness-pill.days-left',
		defaultMessage: ' {days, plural, one {#{symbol} day} other {#{symbol} days}} left',
		description: 'Days left until the GP end date',
	},
});
